const InterceptorType = Object.freeze({
                                        REQUEST: 'request',
                                        RESPONSE: 'response',
                                      });

export default InterceptorType;
